<template>
  <div class="list-box">
    <div class="trade-list">
      <!-- <van-tabs @click="onClick">
        <van-tab title="待接单"></van-tab>
        <van-tab title="已接单"></van-tab>
      </van-tabs> -->
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="trade-item"
            v-for="(item, index) in lists"
            :key="index"
            @click="gotoDetail(val, item.orderUuid)"
          >
            <img class="img" :src="item.photoUrl || defaultHousePhoto" />
            <div class="right-content">
              <div class="trade-title">
                <b>{{
                  item.estateName +
                    item.buildingNo +
                    item.unitName +
                    item.roomNo
                }}</b>
                <p>
                  {{
                    `${item.square}㎡/${item.countF}-${item.countT}-${item.countW}-${item.countY}`
                  }}
                </p>
                <span v-show="item.txTime" class="timeStyle">{{ item.txTime + "签约" }}</span>
                <span v-if="!item.flowName" class="follow">{{
                  "无流程"
                }}</span>
                <p v-if="item.flowName" :style="{ marginTop: '10px' }">
                  办理流程：{{ item.flowName }}
                </p>
                <p v-if="item.finishStatus">
                  按揭当前状态：{{ item.finishStatus }}
                </p>
                <p v-if="item.transferFinishStatus">
                  过户当前状态：{{ item.transferFinishStatus }}
                </p>
                <p v-if="item.processName">
                  当前步骤：{{ item.processName }}
                </p>
                <p v-if="item.executeStatus === 'HANDLE_SUCCESS'&&item.completeTime">
                  按揭办理完成时间：{{ item.completeTime }}
                </p>
                <p v-if="item.transferExecuteStatus === 'HANDLE_SUCCESS'&&item.transferCompleteTime">
                  过户办理完成时间：{{ item.transferCompleteTime }}
                </p>
              </div>
              <!-- <div
                :style="{
                  textAlign: 'right',
                  marginRight: '30px',
                  marginTop: '15px'
                }"
                v-if="
                  item.executeStatus === 'HANDLE_SUCCESS'
                "
              >
                <Button
                  @click.stop="gotoComment(val, item)"
                  :style="{
                    backgroundColor: '#ff9000',
                    color: 'white',
                    width: '66px',
                    height: '30px',
                    borderRadius: '4px',
                    borderWidth: '0px'
                  }"
                  >评价</Button
                >
              </div> -->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { transferList } from "../../api/api";
import { getTime } from "../../utils/tool";
export default {
  data: () => ({
    isLoading: false,
    loading: false,
    finished: false,
    type: "0",
    pageNum: 1,
    pageSize: 10,
    totalCount: 0,
    lists: [],
    defaultHousePhoto:
      "https://image.qfstatic.com/qiaofang/2019/09/20190904/efeb11fa597441cf9667ede268713a1a/photo"
  }),
  created() {
    this.transactionListReq();
  },
  methods: {
    onClick(name, title) {
      console.log(name, title);
      this.pageNum = 1;
      this.type = name == 0 ? "0" : 1;
      this.transactionListReq();
    },

    // 下拉刷新
    onRefresh() {
      this.pageNum = 1;
      setTimeout(() => {
        this.$toast("刷新成功");
        this.transactionListReq();
      }, 500);
    },
    // 加载更多
    onLoad() {
      this.transactionListReq();
    },

    transactionListReq() {
      const params = {
        page: { pageNum: this.pageNum, pageSize: this.pageSize }
      };

      console.log(params);
      transferList(params)
        .then(res => {
          console.log("res===>", res);
          res.data.items.map((value, index, array) => {
            console.log(value, index, array);
            if (value.txTime) {
              value.txTime = getTime(value.txTime);
            }
          });

          this.lists =
            this.pageNum === 1
              ? res.data.items
              : this.lists.concat(res.data.items);
          this.totalCount = res.data.count;
          this.isLoading = false; // 表示加载完成
          this.loading = false; // 加载状态结束
          if (Math.ceil(this.totalCount / this.pageSize) <= this.pageNum) {
            this.finished = true;
          } else {
            this.pageNum++;
            this.finished = false;
          }
        })
        .catch(e => {
          console.log("catch", e);
        });
    },

    gotoComment(val, item) {
      console.log("item=====>", item);
      localStorage.setItem("transferItem", JSON.stringify(item));
      this.$router.push("/customer/comment");
    },

    gotoDetail(item, orderUuid) {
      this.$router.push("/customer/transferDetail?orderUuid=" + orderUuid);
    }
  }
};
</script>
<style lang="scss" scoped>
.trade-list {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-bottom: 50px;
}
.p-10 {
  padding: 10px;
}
.trade-item {
  background-color: white;
  justify-content: space-between;
  display: flex;
  border-bottom: 1px solid #eeeeee;
  font-size: 14px;
  padding-bottom: 10px;
  .img {
    margin-left: 16px;
    margin-top: 16px;
    width: 90px;
    height: 90px;
    margin-right: 20px;
  }
  .right-content {
    margin-top: 10px;
    width: 100%;
    .timeStyle {
      padding: 2px;
      border-radius: 3px;
      color: white;
      background-color: #abc7ff;
      margin-bottom: 10px;
    }
    .follow {
      padding: 2px;
      border-radius: 3px;
      margin-left: 10px;
      color: white;
      background-color: #d9d9d9;
    }
    .trade-title {
      color: #333333;
      text-align: left;
      b {
        font-weight: 600;
        font-size: 14px;
      }
      p {
        margin-top: 2px;
        font-size: 12px;
      }
      span {
        margin-top: 2px;
        font-size: 12px;
      }
    }
  }
}
</style>
